export default {
      id: "education-usage",
      viewBox: "0 0 16 14",
      url: "/assets/" + "icons.svg#education",
      toString: function () {
        return this.url;
      }
    }